import React from 'react'
import { Loader, Text, TextInput } from '@common/ui'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.entity.field.Field

export type EntityFormNumberInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
}

const EntityFormNumberInput = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
}: EntityFormNumberInputProps) => (
  <>
    <TextInput
      key={`field-${field.id.toString()}`}
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
      error={error}
      disabled={disabled || loading}
      placeholder={loading ? ' ' : undefined}
      rightSection={loading ? <Loader size="xs" /> : undefined}
    />
    {fieldValue?.value && Number.isNaN(parseFloat(fieldValue.value)) && <Text>Please enter a valid number</Text>}
  </>
)

export default EntityFormNumberInput
